module.exports = __webpack_public_path__ + "img/1.4a2dca9e.jpg";